import React, { useContext } from "react";
import { Button, Flex } from "@fluentui/react-northstar";
import pl from "shared/messages/pl";
import styles from "./mobileSearchEntityResult.module.scss";
import { SearchEntity } from "view360Card/models";
import { SearchEntityTypeIcon } from "../searchEntityTypeIcon/SearchEntityTypeIcon";
import { MobileViewCard } from "../mobileViewCard/MobileViewCard";
import { constants } from "shared/constants";
import { MobileViewCardDetailsItem } from "..";
import { MsTeamsContext } from "msTeams/store";

export interface MobileSearchEntityResultProps {
    entity: SearchEntity;
    onEntitySelected: (searchEntity: SearchEntity) => void;
}

export const MobileSearchEntityResult: React.FC<MobileSearchEntityResultProps> = (props) => {
    const msTeamsContext = useContext(MsTeamsContext);

    const getActionButton = () => {
        return (
            <Flex className={styles.view360button} hAlign="center">
                <Button
                    size="small"
                    primary
                    onClick={() => {
                        props.onEntitySelected(props.entity);
                    }}
                >
                    {pl.view360Card.view360}
                </Button>
            </Flex>
        );
    };

    const getDetailsRows = () => {
        if (!props.entity.intermediaryList) {
            return null;
        }

        return props.entity.intermediaryList.map((i) => {
            return <MobileViewCardDetailsItem content={i} />;
        });
    };

    return (
        <MobileViewCard
            header={props.entity.name ?? constants.noValue}
            headerIcon={<SearchEntityTypeIcon
                additionalClassName={msTeamsContext.currentMsTeamsThemeName === "default" ? styles.defaultRow : styles.darkRow}
                size="large"
                entityType={props.entity.entityType} />}
            detailsItems={getDetailsRows()}
            footer={getActionButton()}
        />
    );
};
